import { Flex } from '@primitives/Layout'
import { fontSizes, Heading } from '@utils/Typography'
import React from 'react'
import { InlineLink } from '../shared/InlineLink'

export const RelatedArticles = ({ articles = [] }) => {
  if (!articles.length) {
    return null
  }

  return (
    <Flex
      as="section"
      aria-label="Related articles"
      flexDirection="column"
      gap={2}
      mt={5}
      pt={4}
      width="100%"
      css={{ borderTop: '1px solid #EDEDED' }}
    >
      <Heading as="h2" fontSize={fontSizes.body} m={0}>
        Related articles
      </Heading>
      <Flex as="ul" flexDirection="column" gap={2} m={0} p={0} width="100%">
        {articles.map(({ slug, title }) => (
          <Flex as="li" key={slug} css={{ listStyle: 'none' }}>
            <InlineLink to={slug}>{title}</InlineLink>
          </Flex>
        ))}
      </Flex>
    </Flex>
  )
}
